import { useEffect, memo, useCallback } from 'react'
import { useDispatch, useSelector } from '@tabeeb/store'
import {
  resetContentsSearchState,
  searchTargetContentForSharing,
  setContentsForSharing,
  updateSearchContentText,
} from '@tabeeb/modules/contentSharings/actions'
import { getContentSearchState, getContentSharingDialogState } from '@tabeeb/modules/contentSharings/selectors'
import { useDebouncedValue } from '@tabeeb/modules/shared/utils/hooks'
import { SearchResultRowBtn } from '@tabeeb/modules/contentSharings/constants/enums'
import { Stack, TextField } from '@collaborate-health/uikit'
import SearchContentResult from '../SearchContentResult'
import SearchContentResultItem from '../SearchContentResultItem'

interface ContentDestinationProps {
  isDisabled: boolean
}

const ContentDestination: React.FC<ContentDestinationProps> = ({ isDisabled }) => {
  const dispatch = useDispatch()
  const { user, targetContents, tenant } = useSelector(getContentSharingDialogState)
  const { searchText } = useSelector(getContentSearchState)
  const debouncedSearchQuery = useDebouncedValue(searchText, 500)
  const targetContent = targetContents[0]

  useEffect(() => {
    if (debouncedSearchQuery && user) {
      dispatch(
        searchTargetContentForSharing.request({
          searchQuery: debouncedSearchQuery,
          contentOwnerId: user.Id,
          tenantId: tenant?.Id,
        })
      )
    }

    if (!debouncedSearchQuery) {
      dispatch(resetContentsSearchState())
    }
  }, [debouncedSearchQuery, dispatch, user, tenant])

  const _handleContentClick = useCallback(() => {
    dispatch(setContentsForSharing([]))
  }, [dispatch])

  return (
    <Stack>
      {!targetContent && (
        <TextField
          value={searchText}
          onChange={(e) => dispatch(updateSearchContentText(e.target.value))}
          disabled={isDisabled}
        />
      )}
      <Stack>
        {!targetContent && <SearchContentResult />}
        {targetContent && (
          <SearchContentResultItem
            content={targetContent}
            button={SearchResultRowBtn.Remove}
            handleButtonClick={_handleContentClick}
          />
        )}
      </Stack>
    </Stack>
  )
}

export default memo(ContentDestination)

